import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { NgClass, DatePipe } from '@angular/common';

import { Recording, RecordStatus } from '../../data-models/recording.typings';
import { ModalsService, ConfirmableActions } from '../../services/modals.service';
import { RecordingsService } from '../../services/recordings.service';

@Component({
  selector: 'app-player',
  templateUrl: './player.component.html',
  styleUrls: ['./player.component.scss']
})
export class PlayerComponent implements OnInit {

  private isOpened = false;
  private isLaunched = false;
  private source = '';
  private percenteg = 0;
  private interval;
  private coof: number;
  private currentTime = 0;
  private recId = '';
  private recordings: Recording[];
  private currentRecording: Recording;
  private prevDisabled: boolean;
  private nextDisabled: boolean;

  @ViewChild('Audio') private audio: ElementRef;

  constructor(
    private recordingsDB: RecordingsService,
    private modals: ModalsService,
    private datePipe: DatePipe
  ) {
  }

  ngOnInit() {
    this.currentRecording = this.recordingsDB.generateRecording();

    this.modals.togglePlayerEvent.subscribe((data: PlayerLaunch) => {
      if (data.isOpened) {
        this.recordings = this.recordingsDB.lastSortedrecordings;
        this.recId = data.recordingId;
        this.isOpened = data.isOpened;
        this.selectRecording(this.recId);
        setTimeout(() => this.play(), 500);
      } else {
        this.isOpened = data.isOpened;
      }
    });

  }


  play_pause() {
    if (this.isLaunched) {
      this.pause();
    } else {
      this.play();
    }
  }


  play() {
    const audio = this.audio.nativeElement;

    if (!this.currentRecording.isPlayed) {
      this.recordingsDB.markAsPlayed(this.currentRecording);
    }

    this.isLaunched = true;
    audio.play();
    this.interval = setInterval(() => {
      const audioTime = Math.ceil(audio.currentTime * 1000);

      this.coof = 100 / audio.duration;
      this.currentTime = audioTime > 2000 ? audioTime - 500 : audioTime;

      setTimeout(() => {
        const time = audio.currentTime;
        const percenteg = Math.floor(time * this.coof);
        if (!percenteg) {
          console.error('Player progress bar bad value, calc variables: ', this.percenteg, time, this.coof);
          this.percenteg = 0;
        } else {
          this.percenteg = percenteg;
        }
      });
      if (this.percenteg >= 100) {
        this.resetPlayer();
      }
    }, 300);
  }


  pause() {
    this.isLaunched = false;
    this.audio.nativeElement.pause();
    clearInterval(this.interval);
  }


  resetPlayer() {
    this.pause();
    this.audio.nativeElement.currentTime = 0;
    this.currentTime = 0;
  }


  nextRecording() {
    let index = this.recordings.findIndex(rec => rec.recordingId === this.currentRecording.recordingId);

    this.resetPlayer();
    this.selectRecording(this.recordings[++index].recordingId);
  }


  prevRecording() {
    let index = this.recordings.findIndex(rec => rec.recordingId === this.currentRecording.recordingId);

    this.resetPlayer();
    this.selectRecording(this.recordings[--index].recordingId);
  }


  selectRecording(id: string) {
    const index = this.recordings.findIndex(rec => rec.recordingId === id);
    this.nextDisabled = false;
    this.prevDisabled = false;

    this.currentRecording = this.recordings[index];

    switch (index) {
      case 0: this.prevDisabled = true; break;
      case this.recordings.length - 1: this.nextDisabled = true; break;
    }
    if (this.recordings.length === 1) {
      this.prevDisabled = true;
      this.nextDisabled = true;
    }

    if (this.currentRecording.title === '') {
      this.currentRecording.title = '<NoTitle>';
    }

    if (this.currentRecording.status !== RecordStatus.Recorded) {
      this.nextRecording();
    } else {
      this.source = this.currentRecording.recordingUrl;
      this.audio.nativeElement.load();
      this.percenteg = 0;
    }
  }


  close() {
    this.resetPlayer();
    this.modals.togglePlayerEvent.emit({
      isOpened: false,
      recordingId: ''
    });
  }


  delete() {
    const len = this.recordings.length;

    this.modals.openWarning(
      'Delete',
      'Are you sure you want to delete this recording?',
      ConfirmableActions.Delete
    ).then((isAgreed: boolean) => {
      if (isAgreed) {
        this.recordingsDB.delete(this.currentRecording);
        this.close();
      }
    });
  }


  download() {
    this.recordingsDB.download(this.currentRecording);
  }


  getTitleTooltip(): string {
    let response: string;

    if (this.currentRecording.title.length > 40) {
      response = this.currentRecording.title;
    } else {
      response = '';
    }

    return response;
  }

  getUrl(): string {
    return this.recordingsDB.getDownloadUrl(this.currentRecording);
  }
}

export interface PlayerLaunch {
  recordingId: string;
  isOpened: boolean;
}



// WEBPACK FOOTER //
// ./src/app/main/player/player.component.ts